import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MainMenuComponent } from './main-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MenubarModule } from 'primeng/menubar';
import {IrbCommonModule} from '@irb-common/irb-common.module';
import { ExportsPanelComponent } from './exports-panel/exports-panel.component';

@NgModule({
  imports: [
    CommonModule,
    CdkAccordionModule,
    RouterModule,
    MatIconModule,
    MatMenuModule,
    MenubarModule,
    IrbCommonModule
  ],
  declarations: [
    MainMenuComponent,
    ExportsPanelComponent
  ],
  exports: [
    MainMenuComponent
  ]
})
export class MainMenuModule {}
